/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Measurement_DescriptionInputs */

const en_cookie_measurement_description = /** @type {(inputs: Cookie_Measurement_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These cookies help us understand how visitors interact with the website and improve its performance.`)
};

const lv_cookie_measurement_description = /** @type {(inputs: Cookie_Measurement_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šīs sīkdatnes palīdz mums saprast, kā apmeklētāji lieto vietni, un uzlabot tās darbību.`)
};

/**
* | output |
* | --- |
* | "These cookies help us understand how visitors interact with the website and improve its performance." |
*
* @param {Cookie_Measurement_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cookie_measurement_description = /** @type {((inputs?: Cookie_Measurement_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Measurement_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cookie_measurement_description(inputs)
	return en_cookie_measurement_description(inputs)
});